export enum EnrollmentState {
  INITIAL,
  TERMS_ACCEPTED,
  ENROLLMENT_ACCEPTED,
}

export type UserAccountForm = {
  emailAddress: string;
  lastName: string;
  firstName: string;
  middleInitial: string;
  phoneNumber: string;
};

export type SaveUserAccountForm = UserAccountForm & { confirmEmail: string };

export const emailValidationRegex =
  /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/g;
